import { ApplicationState } from "../store";
import { blacklistedPartnerListForNevigateYourDashboardVideo } from "../util/partner";

const flowName = {
    // Next-Step-Flow
    dashboardDarkwebScan: "DASHBOARD-DARKWEB-SCAN",
    dashboardReconnectFinancialAccount: "DASHBOARD-RECONNECT-FINANCIAL-ACCOUNT",
    dashboardReconnectSocialMedia: "DASHBOARD-RECONNECT-SOCIAL-MEDIA",
    dashboardSSNPinningRequired: "SSN-PINNING-REQUIRED",
    // Let's Get Started Flow
    createYourProfile: "CREATE-YOUR-PROFILE",
    NAVIGATING_YOUR_DASHBOARD: "NAVIGATING-YOUR-DASHBOARD",
};

const FLOW_STEP_COMPLETED_STATUS: string = "COMPLETED";
const SECURITY_ASSESSMENT_METER_STATUS: string = "SECURITY-ASSESSMENT-METER-STATUS";
const TAKE_YOUR_SECURITY_ASSESSMENT: string = "TAKE-YOUR-SECURITY-ASSESSMENT";
const BUSINESS_PROFILE_STATUS: string = "BUSINESS-PROFILE-STATUS";
const ADD_YOUR_ADDITIONAL_BUSINESS_INFORMATION: string = "ADD-YOUR-ADDITIONAL-BUSINESS-INFORMATION";

const letsGetStartedFlowConfig = [
    {
        flowName: "CREATE-YOUR-PROFILE",
        link: "",
        eventName: "Create Your Profile",
        logo: "check-circle",
        isLinkCompletion: false,
    },
    {
        flowName: "NAVIGATING-YOUR-DASHBOARD",
        link: "",
        eventName: "Navigate Your Dashboard",
        logo: "home",
        isLinkCompletion: false,
    },
    {
        flowName: "DOWNLOAD-OUR-MOBILE-APP",
        link: "/manage-account/my-account",
        eventName: "Download Our Mobile App",
        logo: "download",
        isLinkCompletion: false,
    },
    {
        flowName: "ADD-FAMILY-MEMBER",
        link: "",
        eventName: "Add Family Member",
        logo: "user-plus",
        isLinkCompletion: false,
    },
    {
        flowName: "ADD-YOUR-FINANCIAL-ACCOUNTS",
        link: "/transactions/financial-account",
        eventName: "Add your Financial Accounts",
        logo: "university",
        isLinkCompletion: false,
    },
    {
        flowName: "ADD-YOUR-SOCIAL-MEDIA-ACCOUNTS",
        link: "/identity-vault#social-media-accounts",
        eventName: "Add your Social Media Accounts",
        logo: "users",
        isLinkCompletion: false,
    },
    {
        flowName: "ADD-YOUR-ADDITIONAL-INFORMATION",
        link: "/identity-vault",
        eventName: "Add your Additional Information",
        logo: "info-circle",
        isLinkCompletion: false,
    },
    {
        flowName: ADD_YOUR_ADDITIONAL_BUSINESS_INFORMATION,
        link: "/identity-vault",
        eventName: "Add your Additional Information",
        logo: "info-circle",
        isLinkCompletion: false,
    },
    {
        flowName: "REVIEW-YOUR-CREDIT-SCORE",
        link: "/credit/score",
        eventName: "Review Your Credit Score",
        logo: "tachometer-alt",
        isLinkCompletion: true,
    },
    {
        flowName: "REVIEW-YOUR-CREDIT-REPORT",
        link: "/creditAuth/report",
        eventName: "Review Your Credit Report",
        logo: "file-invoice",
        isLinkCompletion: true,
    },
    {
        flowName: "CHECK-OUT-YOUR-PASSWORD-MANAGER",
        link: "/identity-vault/password-manager",
        eventName: "Check Out Your Password Manager",
        logo: "key",
        isLinkCompletion: false,
    },
    {
        flowName: "LOST-WALLET-ASSISTANCE",
        link: "/identity-vault/secure-storage",
        eventName: "Lost Wallet Assistance",
        logo: "wallet",
        isLinkCompletion: false,
    },
    {
        flowName: "DISCOVER-ADDITIONAL-RESOURCES",
        link: "/resources",
        eventName: "Discover Additional Resources",
        logo: "open-book",
        isLinkCompletion: true,
    },
    {
        flowName: "TAKE-YOUR-SECURITY-ASSESSMENT",
        link: "/resources/security-assessment",
        eventName: "Take Your Security Assessment",
        logo: "shield-alt",
        isLinkCompletion: false,
    },
    {
        flowName: BUSINESS_PROFILE_STATUS,
        link: "/credit/score",
        eventName: "Link Business Profile",
        logo: "building",
        isLinkCompletion: false,
    },
];

const getFlowByName = (state: ApplicationState, flowName: string) => {
    if (state.nextStepFlowState && state.nextStepFlowState.userLetsGetStartedFlows) {
        const selectedFlow = state.nextStepFlowState.userLetsGetStartedFlows.find((flow) => flow.flowName === flowName);
        return selectedFlow;
    }
    return null;
};

export function isBlackListedPartnerForNevigateYourDashboardLinkOnGetStarted(partnerId: number) {
    return blacklistedPartnerListForNevigateYourDashboardVideo.includes(partnerId);
}

export {
    flowName,
    letsGetStartedFlowConfig,
    getFlowByName,
    FLOW_STEP_COMPLETED_STATUS,
    SECURITY_ASSESSMENT_METER_STATUS,
    TAKE_YOUR_SECURITY_ASSESSMENT,
    BUSINESS_PROFILE_STATUS,
    ADD_YOUR_ADDITIONAL_BUSINESS_INFORMATION,
};
